var $ = require('../internals/export');

var isObject = require('../internals/is-object');

var onFreeze = require('../internals/internal-metadata').onFreeze;

var FREEZING = require('../internals/freezing');

var fails = require('../internals/fails'); // eslint-disable-next-line es-x/no-object-seal -- safe


var $seal = Object.seal;
var FAILS_ON_PRIMITIVES = fails(function () {
  $seal(1);
}); // `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal

$({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES,
  sham: !FREEZING
}, {
  seal: function seal(it) {
    return $seal && isObject(it) ? $seal(onFreeze(it)) : it;
  }
});